module.exports = __webpack_public_path__ + "img/waistband width.f8e0191d.png";